import { storageActions } from "./StorageReducer";
import { useStorageAPI  } from '../../api/storage/useStorageAPI';
import { data } from "react-router-dom";

export const useStorage = () => {
  const api = useStorageAPI();
  const request = {
      get: (params) => {
        return async (dispatch) => {
          try {
            const response = await api.storage.get(params);
            dispatch(storageActions.funGetStorage(response));
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        }
      }
  };
  return { request };
};